import {
    dataUpdationFromSocket,
    addingRowsFromSocketLazyLoad,
    addingRowsFromSocketLoadAllRows,
    addNewSubsheetRowsToGrid,
    updateSubsheetRowsInGrid,
    deletingRowsFromSocket
} from './dataUpdationHandlers/rowAdditionAndUpdationHandler';
import {notifyDataUpdationFromSocket, flashCellOnce, normalizeColOptions} from './utils';

function checkIfUserTriggeredTheAction(fromWebFormOrEmail, clientId) {
    if (`OnTriggerExecution_${window.appStore.clientId}` === clientId) {
        return !fromWebFormOrEmail && true;
    }
    return false;
}

export function handleUpdatedAndNewRowsDataFromSocket(domain, listId, updatedData, newRows, parentRows, userName, isSubsheet, fromWebFormOrEmail = false, clientId) {
    try {
        if ((updatedData || newRows) && window.LOGGED_IN_USER.domain === domain && window.appStore.containerStore.listId && window.appStore.clientId !== clientId) {
            let store = isSubsheet ? window?.appStore?.containerStores[listId]?.currentSubsheetStore : window?.appStore?.containerStores[listId]?.currentViewStore;
            if (!store || (isSubsheet && !(window.appStore.currentVisibleListId == listId && parentRows.includes(store?.parentRowId)))) {
              return;
            }

            console.log("into handleUpdatedAndNewRowsDataFromSocket");
            const fromTriggers = checkIfUserTriggeredTheAction(fromWebFormOrEmail, clientId);
            var rowIds = Object.keys(updatedData);
            if (rowIds.length > 0 || newRows.length > 0) {
                let modifiedRowNodes = {};
                let modifiedColData = {};
                let isFilled = false;
                Object.entries(updatedData).forEach(([rowId, info]) => {
                    let targetnode = store?.gridApi?.getRowNode(rowId) ?? store?.gridApi?.getRowNode(info[0]?.uniqueId); //No need of using store.getRowNodeById because however you add a row, uniqueId for that row will be same on all the clients.
                    if (!targetnode || (rowId != targetnode.data?.rowId)) {
                        targetnode = store?.getRowNodeById(rowId, info[0]?.uniqueId)?.node;
                    }
                    if (targetnode) {
                        if (domain === "zi" && listId == '89292547' && store?.view?.id === '179' && store?.view?.name === "Live" && info[0]?.['column_744'] != "Ongoing") {
                            deletingRowsFromSocket(store, [info[0]?.['row_id']], userName, false);
                            window.appStore.notificationStore.showNotification(`Row ${info[0]?.['row_id']} updated by ${userName ? userName : 'other user.'}`, 'info');
                        } else {
                            dataUpdationFromSocket(store, targetnode, info[0]);
                            modifiedRowNodes[rowId] = targetnode;
                            if (!isFilled) {
                                for (let idx = 1; idx < info.length; idx++) {
                                    modifiedColData[info[idx]['columnName']] = info[idx]['columnPath'];
                                }
                                isFilled = true;
                            }
                        }
                    } else {
                        if (domain === "zi" && listId == '89292547' && store?.view?.id === '179' && store?.view?.name === "Live" && info[0]?.['column_744'] == "Ongoing") {
                            addingRowsFromSocketLoadAllRows(store, [info[0]], userName, false, false, false, false);
                        }
                    }
                });
                if (newRows.length > 0 && store.isLazyLoadEnabled) {
                    const rowsToBeFlashed = addingRowsFromSocketLazyLoad(store, newRows, userName, fromWebFormOrEmail, fromTriggers);
                    let rowAlertMessage = "New row(s) added by ";
                    if (rowsToBeFlashed.length > 0) {
                        notifyDataUpdationFromSocket(rowAlertMessage, userName, rowsToBeFlashed, [], store, fromWebFormOrEmail, fromTriggers);
                    }
                } else if (newRows.length > 0) {
                    addingRowsFromSocketLoadAllRows(store, newRows, userName, isSubsheet, fromWebFormOrEmail, fromTriggers);
                }
                var rowsToBeFlashed = Object.values(modifiedRowNodes);

                if (rowsToBeFlashed.length > 0) {
                    const rowsInMsg = rowIds.length > 5 ? rowIds.slice(0,5).join(', ') + ',...' : rowIds.join(', ');
                    let alertMessage = isSubsheet ? 'Subsheet data updated by ': 'Sheet data updated by ';
                    if (rowIds.length == 1) {
                        alertMessage = isSubsheet ? `Subsheet Row #${rowsInMsg} updated by ` : `Row #${rowsInMsg} updated by `;
                    } else {
                        alertMessage = isSubsheet ? `Subsheet Rows #${rowsInMsg} updated by ` : `Rows #${rowsInMsg} updated by `;
                    }
                    notifyDataUpdationFromSocket(alertMessage, userName, rowsToBeFlashed, Object.values(modifiedColData), store, fromWebFormOrEmail, fromTriggers);
                }
                if (store && typeof store.onRowDataUpdated === "function") {
                    store.onRowDataUpdated();
                }
            }
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}

export function handleSubsheetDataUpdationThroughFormViaSocket (domain, subsheetData, listId, parentRowId, userName, clientId) {
    try {
        Object.entries(subsheetData).forEach(([sublistId, rowData]) => {
            const store = window?.appStore?.containerStores[sublistId]?.currentSubsheetStore;
            if (store && window.LOGGED_IN_USER.domain === domain && window.appStore.currentVisibleListId == sublistId && parentRowId == store.parentRowId && window.appStore.clientId !== clientId) {
                console.log("into handleSubsheetDataUpdationThroughFormViaSocket");
                if (rowData['newRows'].length > 0) {
                    addNewSubsheetRowsToGrid(store, rowData['newRows']);
                }
                if (Object.keys(rowData['updatedRows']).length > 0) {
                    updateSubsheetRowsInGrid(store, rowData['updatedRows']);
                }
                if (rowData['deletedRows'].length > 0) {
                    deletingRowsFromSocket(store, rowData['deletedRows'], userName, false);
                }
                window.appStore.notificationStore.showNotification(userName ? `Subsheet data modified by ${userName}.` : 'Subsheet data modified by other user.', 'info');
            }

        });
    } catch (error) {
        console.error("Error: ", error);
    }

}

export function handleCommentsUpdationFromSocket(domain, listId, rowId, uniqueId, comments, commentsCount, userName, clientId) {
    try {
        if (rowId && window.LOGGED_IN_USER.domain === domain && window.appStore.containerStore.listId && window.appStore.clientId !== clientId) {
            let store = window?.appStore?.containerStores[listId]?.currentViewStore;
            if (store) {
                const fromTriggers = checkIfUserTriggeredTheAction(false, clientId);
                let targetnode = store?.getRowNodeById(rowId, uniqueId)?.node;
                if (targetnode && targetnode.data) {
                    targetnode.data.comments = comments;
                    targetnode.data.comments_count = commentsCount;
                    targetnode.setData(targetnode.data);
                    store.comments[rowId] = commentsCount;
                    console.log('In handleCommentsUpdationFromSocket before executing redrawRows...');
                    store?.gridApi?.redrawRows({ rowNodes: [targetnode] });

                    let alertMessage = `Comments in row ${rowId} updated by `;

                    notifyDataUpdationFromSocket(alertMessage, userName, [targetnode], ["commentsId"], store, false, fromTriggers);
                }
            }
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}

export function handleRowDeletionFromSocket(deletedRowIds, parentRows, domain, listId, userName, isSubsheet, clientId) {
    try {
        if (deletedRowIds.length > 0 && window.LOGGED_IN_USER.domain === domain && window.appStore.containerStore.listId && window.appStore.clientId !== clientId) {
            let store = isSubsheet ? window?.appStore?.containerStores[listId]?.currentSubsheetStore : window?.appStore?.containerStores[listId]?.currentViewStore;
            if (!store || (isSubsheet && !(window.appStore.currentVisibleListId == listId && parentRows.includes(store?.parentRowId)))) {
              return;
            }
            console.log("into handleRowDeletionFromSocket");
            deletingRowsFromSocket(store, deletedRowIds, userName);
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}

function handleSubsheetColumnConfigChange(columnConfig, listColumns) {
    let isOldColumn = false;
    listColumns.forEach((col) => {
        if (col.id == columnConfig.id) {
            isOldColumn = true;
            col.header = columnConfig.name;
            Object.keys(columnConfig).forEach(
                (key) => (col[key] = columnConfig[key])
            );
            return { ...col, ...columnConfig };
        }
        return col;
    });

    !isOldColumn && listColumns.push(columnConfig);

    return listColumns;
}

function updateColDataIfNoSubsheetStore (parentStore, column, listId, isDeletion = false) {
    if (column.hasOwnProperty('prevHighlightState')) {
        delete column.prevHighlightState;
    }
    try {
        // for (let i = 0; i < parentStore.columnDefs.length; i++) {
        //     const colOptions = normalizeColOptions(parentStore.columnDefs?.[i]?.cellRendererParams?.columnOptions);
        //     const subListId = colOptions?.sub_list_id ?? '';
        //     if (subListId == listId) {
        //         let columnIdx = parentStore.columnDefs[i].cellRendererParams.listColumns.findIndex(subColumn => subColumn.id === column.id);
        //         if (isDeletion) {
        //             if(columnIdx >= 0) {
        //                 parentStore.columnDefs[i].cellRendererParams.listColumns.splice(columnIdx, 1);
        //             }
        //         } else {
        //             if (columnIdx >= 0) {
        //                 parentStore.columnDefs[i].cellRendererParams.listColumns[columnIdx] = column;
        //             } else {
        //                 parentStore.columnDefs[i].cellRendererParams.listColumns.push(column);
        //             }
        //         }
        //         break;
        //     }
        // }

        console.log("into updateColDataIfNoSubsheetStore...");
        if (!isDeletion) {
            for (let k = 0; k < parentStore.listConfig.listData.length; k++) {
                const colOptions = normalizeColOptions(parentStore.listConfig?.listData?.[k]?.options);
                const subListId = colOptions?.sub_list_id ?? '';
                if (subListId == listId) {
                    let listColumns = parentStore.listConfig.listData[k].list_columns;
                    handleSubsheetColumnConfigChange(column, listColumns);
                    break;
                }
            }
        }
        else {
            for (let i = 0; i < parentStore.listConfig.listData.length; i++) {
                const colOptions = normalizeColOptions(parentStore.listConfig?.listData?.[i]?.options);
                const subListId = colOptions?.sub_list_id ?? '';
                if (subListId == listId) {
                    let columnIdx = parentStore.listConfig.listData[i]?.list_columns?.findIndex(subColumn => subColumn.id === column.id);
                    if (columnIdx >= 0) {
                        parentStore.listConfig.listData[i]?.list_columns?.splice(columnIdx, 1);
                    }
                    break;
                }
            }
        }
    } catch (error) {
        console.log('Column Updation error: ', error);
    }
}

export async function handleAddEditColumnFromSocket(domain, listId, column, decimals = 0, userName, isSubsheet, parentListId = 0, isOldColumn, shouldRefreshData, shouldRedrawRefreshedRows, clientId) {
    try {
        if (column && window.LOGGED_IN_USER.domain === domain && window.appStore.containerStore.listId && window.appStore.clientId !== clientId) {
            let store = isSubsheet ? window?.appStore?.containerStores[listId]?.currentSubsheetStore : window?.appStore?.containerStores[listId]?.currentViewStore;
            if (!store || (isSubsheet && !(window.appStore.currentVisibleListId == listId)) || (window.appStore.currentVisibleListId && window.appStore.currentVisibleListId !== listId)) {  //When subsheet is opened and main sheet column is updated, that data should not be updated it closes the subsheet to refresh.
                if (!store && isSubsheet && parentListId) {
                    const parentStore = window.appStore.containerStores[parentListId]?.currentViewStore;
                    if (parentStore) {
                        updateColDataIfNoSubsheetStore(parentStore, column, listId);
                    }
                } else if(store && isSubsheet && parentListId && window.appStore.currentVisibleListId == "") {
                    let prevHighlightState = column?.prevHighlightState ?? false;
                    if (column.hasOwnProperty('prevHighlightState')) {
                        delete column.prevHighlightState;
                    }
                    store.addColumnStore?.onColumnConfigChange({...column, prevHighlightState}, decimals);
                }
                return;
            }

            let prevHighlightState = column?.prevHighlightState ?? false;
            if (column.hasOwnProperty('prevHighlightState')) {
                delete column.prevHighlightState;
            }

            if (isOldColumn && column.column_type_id == '3') {
                await store?.refreshData(); //when row coloring is done based on dropdown, and then if we need to reflect dropdown options changes and colors accordingly then we need to refreshData as in saveColumn function
            }
            if (!isSubsheet) {
                store.containerStore.addColumn(column, false);
                const columnOptions = JSON.parse(column.options);
                if (columnOptions[0].is_highlighted) {
                    if (isOldColumn && (!prevHighlightState || (prevHighlightState && (column.column_type_id == "22" || column.column_type_id == "5" || column.column_type_id == "17")))) {
                        await store?.getDuplicateColumnsData?.({["column_" + column.id] : column.column_type_id});
                    } else if (!isOldColumn && store?.duplicateColumnsData) {
                        store.duplicateColumnsData["column_" + column.id] = {};
                        const duplicateColumn = {
                            ...column,
                            options: (() => {
                                const parsedOpts = JSON.parse(column.options);
                                return Array.isArray(parsedOpts) ? (parsedOpts[0] ?? {}) : parsedOpts;
                            })()
                        };
                        store.duplicateColumnsConfigs["column_" + column.id] = duplicateColumn;
                    }
                    if (shouldRedrawRefreshedRows) {
                        if (shouldRefreshData) {
                            console.log("before refreshData in handleAddEditColumnForSocket...");
                            store?.refreshData();
                        }
                        console.log("before redrawRefreshedRows in handleAddEditColumnForSocket...");
                        store?.redrawRefreshedRows();
                    }
                }
                else if (!columnOptions[0].is_highlighted && store.duplicateColumnsData["column_" + column.id]) {
                    delete store.duplicateColumnsData["column_" + column.id];
                }
            } else {
                store.addColumnStore?.onColumnConfigChange({...column, prevHighlightState}, decimals);
            }
            const columnId = column.alias_path;
            const message = isOldColumn ? `Column ${column.name} edited by ` : `New Column ${column.name} added by `;
            const headerEl = document.querySelector(`.ag-header-cell[col-id="${columnId}"]`);
            notifyDataUpdationFromSocket(message, userName, [], [column.alias_path], store, false);
            if (headerEl) {
                headerEl.classList.add('ag-flash');
                setTimeout(() => {
                    headerEl.classList.remove('ag-flash');
                }, 5000);
            }
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}

export async function handleDeleteColumnFromSocket(domain, listId, columnId, isSubsheet = false, parentListId = 0, userName, clientId) {
    try {
        if (columnId && window.LOGGED_IN_USER.domain === domain && window.appStore.containerStore.listId && window.appStore.clientId !== clientId) {
            let store = isSubsheet ? window?.appStore?.containerStores[listId]?.currentSubsheetStore : window?.appStore?.containerStores[listId]?.currentViewStore;
            if (!store || (isSubsheet && !(window.appStore.currentVisibleListId == listId)) || (window.appStore.currentVisibleListId && window.appStore.currentVisibleListId !== listId)) {  //When subsheet is opened and main sheet column is updated, that data should not be updated it closes the subsheet to refresh.
                if (!store && isSubsheet && parentListId) {
                    const parentStore = window.appStore.containerStores[parentListId]?.currentViewStore;
                    if (parentStore) {
                        updateColDataIfNoSubsheetStore(parentStore, {'id': columnId}, listId, true);
                    }
                } else if(store && isSubsheet && parentListId && window.appStore.currentVisibleListId == "") {
                    const parentStore = window.appStore.containerStores[parentListId]?.currentViewStore;
                    if (parentStore) {
                        updateColDataIfNoSubsheetStore(parentStore, {'id': columnId}, listId, true);
                    }
                }
                return;
            }
            let subsheetColumnName = '';
            if (!isSubsheet) {
                console.log("before fetchListConfig in handleDeleteColumnForSocket...");
                store.containerStore?.fetchListConfig();
                store.containerStore?.fetchView(store.containerStore?.view.id, true);
            } else {
                subsheetColumnName = await store.addColumnStore.handleColumnDeleteViaSockets(columnId);
            }

            const columnIdx = store.columnDefs.findIndex(column => column.dataIndex == 'column_' + columnId);
            let columnName;
            
            if(columnIdx >= 0) {
                columnName = isSubsheet ? subsheetColumnName : store.columnDefs[columnIdx]?.cellRendererParams?.columnRaw?.name ?? store.columnDefs[columnIdx]?.colId;
                store.columnDefs.splice(columnIdx, 1);
                store.gridApi.setColumnDefs(store.columnDefs);
            } else {
                columnName = isSubsheet ? subsheetColumnName : "";
            }

            const message = `Column ${columnName} deleted by `;
            notifyDataUpdationFromSocket(message, userName, [], [], store, false, false);
        }
    } catch (error) {
        console.error("Error: ", error);
    }
}
